// extracted by mini-css-extract-plugin
export default {"anchor":"Link_anchor__k+JsK"};